module.exports = __webpack_public_path__ + "img/robseeco-bg.183f8808.png";